import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import ClientLogger from './client-logger';
const useClientLogger = () => {
  const $ = _c(3);
  const [clientLogger, setClientLogger] = useState(null);
  let t0;
  if ($[0] !== clientLogger) {
    t0 = () => {
      if (!window.Rollbar || clientLogger) {
        return;
      }
      const rollbar = new ClientLogger(window.Rollbar);
      setClientLogger(rollbar);
    };
    $[0] = clientLogger;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  return clientLogger;
};
export default useClientLogger;